import { render, staticRenderFns } from "./SetInfo.vue?vue&type=template&id=1b5d574f&scoped=true&"
import script from "./SetInfo.vue?vue&type=script&lang=js&"
export * from "./SetInfo.vue?vue&type=script&lang=js&"
import style0 from "./SetInfo.vue?vue&type=style&index=0&id=1b5d574f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d574f",
  null
  
)

export default component.exports